import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Tronque le champ « Action » d'un event (multiligne) pour les vues compactes
 * - cloche, calendrier, timeline. On aplatit les retours ligne en espace
 * avant de couper pour éviter d'afficher « ligne1\n... » qui casserait la
 * mise en forme de la carte.
 */
export function truncateAction(text: string | null | undefined, max = 40): string {
  if (!text) return '';
  const oneLine = text.replace(/\s+/g, ' ').trim();
  return oneLine.length > max ? `${oneLine.slice(0, max).trimEnd()}...` : oneLine;
}
